<template>
  <div
    ref="el"
    class="util-wave"
    :class="{
      'is-clipped': props.blok.clipping,
      'is-top': props.blok.position === 'top',
      ['is-' + props.blok.color]: true,
      ['module-bg-' + moduleSettings.color]: true,
    }">
    <Wave1 v-if="props.blok.asset === 'type-1'" />
    <Wave2 v-if="props.blok.asset === 'type-2'" />
    <Wave3 v-if="props.blok.asset === 'type-3'" />
    <Wave4 v-if="props.blok.asset === 'type-4'" />

    <span style="display: none; position: absolute; top: 0; background-color: white; color: black; opacity: 0.5">
      {{ moduleSettings }}<br />
      {{ props.blok }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { onMounted, reactive, useTemplateRef } from 'vue';
import Wave1 from '~/assets/svg/module-wave-1.svg?skipsvgo';
import Wave2 from '~/assets/svg/module-wave-2.svg?skipsvgo';
import Wave3 from '~/assets/svg/module-wave-3.svg?skipsvgo';
import Wave4 from '~/assets/svg/module-wave-4.svg?skipsvgo';
import type { UtilWaveStoryblok } from '~/types/storyblok-generated';

const el = useTemplateRef<HTMLDivElement>('el');

const props = defineProps<{
  blok: UtilWaveStoryblok;
}>();

/* stores parent module settings */
const moduleSettings = reactive({
  color: 'white',
});

onMounted(() => {
  if (el.value) {
    /* setting "theme" color based on underlying module */
    if (el.value.closest('.core-module')?.classList.contains('is-white')) moduleSettings.color = 'white';
    if (el.value.closest('.core-module')?.classList.contains('is-schaerer-red')) moduleSettings.color = 'schaerer-red';
    if (el.value.closest('.core-module')?.classList.contains('is-brown-light')) moduleSettings.color = 'brown-light';
  }
});
</script>
<style scoped lang="scss">
@use '~/assets/scss/variables';

.util-wave {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 9999;
  // pointer-events: none;
  bottom: 0;

  display: flex;
  align-items: flex-end;

  z-index: 3001;
  overflow: clip;

  &.is-top {
    align-items: flex-start;

    svg {
      bottom: unset;
      left: unset;
      top: -1px;
      right: -1px;
      transform: rotate(180deg);
    }
  }

  /* varianten */
  /* white */

  &.module-bg-white.is-dark {
    --wave-color: #{variables.$schaerer-brown};
    --wave-color-clipped: #{variables.$brown-dark};
  }

  &.module-bg-white.is-red {
    --wave-color: #{variables.$schaerer-red};
    --wave-color-clipped: #{variables.$red-dark};
  }

  &.module-bg-white.is-light {
    --wave-color: #{variables.$brown-medium};
    --wave-color-clipped: #{variables.$brown-medium};
  }

  /* brown light */
  &.module-bg-brown-light.is-dark {
    --wave-color: #{variables.$schaerer-brown};
    --wave-color-clipped: #{variables.$brown-dark};
  }

  &.module-bg-brown-light.is-red {
    --wave-color: #{variables.$schaerer-red};
    --wave-color-clipped: #{variables.$red-dark};
  }

  &.module-bg-brown-light.is-light {
    --wave-color: #{variables.$brown-super-light};
    --wave-color-clipped: #{variables.$brown-super-light};
  }

  /* red */
  &.module-bg-schaerer-red.is-dark {
    --wave-color: #{variables.$brown-dark};
    --wave-color-clipped: #{variables.$brown-light};
  }

  &.module-bg-schaerer-red.is-red {
    --wave-color: #{variables.$red-dark};
    --wave-color-clipped: #{variables.$brown-light};
  }

  &.module-bg-schaerer-red.is-light {
    --wave-color: #{variables.$brown-light};
    --wave-color-clipped: #{variables.$brown-light};
  }

  color: var(--wave-color);

  &.is-clipped {
    color: var(--wave-color-clipped);
  }
}

svg {
  position: absolute;
  width: calc(100% + 2px);
  left: -1px;
  bottom: -1px;
  height: auto;

  * {
    fill: currentColor;
  }
}
</style>
